import React from 'react';
import PropTypes from 'prop-types';
import dateUtils from 'helpers/dateUtils';
import styled from 'styled-components';
import translate from 'components/hoc/translate';

const DateTimeFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const DateTime = styled.div`
    font-size: 16px;
    line-height: 1.2;
    text-transform: capitalize;
`;

const DateTimeField = (props) => {
    const {
        label,
        translate,
        value,
    } = props;

    return (
        <DateTimeFieldWrapper>
            { label &&
                <Label>{ translate(label) }</Label>
            }

            <DateTime>{ dateUtils.formatDateTimeFromString(value) }</DateTime>
        </DateTimeFieldWrapper>
    );
};

DateTimeField.propTypes = {
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default translate(DateTimeField);



// WEBPACK FOOTER //
// ./src/components/show/DateTimeField.js